import { createFileRoute } from "@tanstack/react-router";
import packFront from "@/assets/pack-front.png.asset.json";
import { PACK_OPENING_FAQ as FAQ } from "@/lib/pack-opening-content";

export const Route = createFileRoute("/pack-opening")({
  head: () => ({
    meta: [
      { title: "Palworld Card Pack Opening Simulator — Free Daily Packs" },
      { name: "description", content: "Open Palworld Official Card Game booster packs and trial decks online with real pull rates, official card scans, card grading and 12 free packs a day." },
      { property: "og:title", content: "Palworld Card Pack Opening Simulator" },
      { property: "og:description", content: "Rip Palworld booster packs and trial decks with real pull rates, official card art, grading and daily free packs." },
      { property: "og:url", content: "https://palstars.com/pack-opening" },
      { property: "og:type", content: "website" },
      { property: "og:image", content: `https://palstars.com${packFront.url}` },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: `https://palstars.com${packFront.url}` },
    ],
    links: [{ rel: "canonical", href: "https://palstars.com/pack-opening" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "BreadcrumbList",
              itemListElement: [
                { "@type": "ListItem", position: 1, name: "Pal Stars", item: "https://palstars.com/" },
                { "@type": "ListItem", position: 2, name: "Pack Opening", item: "https://palstars.com/pack-opening" },
              ],
            },
            {
              "@type": "FAQPage",
              mainEntity: FAQ.map((f) => ({
                "@type": "Question",
                name: f.q,
                acceptedAnswer: { "@type": "Answer", text: f.a },
              })),
            },
          ],
        }),
      },
    ],
  }),
});
